import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const PermissionsPage = lazy(() => import('~/features/platform/pages/permissions-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/permissions')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <PermissionsPage />
    </Suspense>
  ),
});
